import React, { useState, useEffect } from 'react';
import '../styles/Amount.css';

const formatAmount = (amount) => {
  return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const Amount = ({ amount, setAmount }) => {

  useEffect(() => {
    setAmount(amount.toString());
  }, [amount]);

  const handleChange = (e) => {
    const cleanText = e.target.value.replace(/,/g, '');
    setAmount(cleanText);
  };

  return (
    <div className="amount-container">
      <label className="amount-label">Amount: GH₵</label>
      <input
        type="text"
        value={formatAmount(amount)}
        onChange={handleChange}
        placeholder="Enter amount"
        className="amount-input"
      />
    </div>
  );
};

export default Amount;
